import React from 'react'
import "./PageNotFound.css"

function PageNotFound() {
  return (
    <div className="nb qw alo abc">
   <main className="ab ec rb">
      <img src="https://images.unsplash.com/photo-1545972154-9bb223aac798?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;ixlib=rb-1.2.1&amp;auto=format&amp;fit=crop&amp;w=3050&amp;q=80&amp;exp=8&amp;con=-15&amp;sat=-75" alt="" className="aa ak ed ph tn aqe aqj"/>
      <div className="gx ua ark asb avl cfo ddh">
         <p className="avy awg awr bah">404</p>
         <h1 className="lh avs awd awx bah chy">Page not found</h1>
         <p className="lh avy baj bxl">Sorry, we couldn’t find the page you’re looking for.</p>
         <div className="kw lx ze"><a href="/" className="awa awg awq bah"><span aria-hidden="true">←</span> Back to home</a></div>
      </div>
   </main>
</div>
  )
}

export default PageNotFound
